import { Navigate, Route, Routes } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { Login } from './components/Login'
import { ResetPassword } from './components/ResetPassword'
import { AppShell } from './layouts/AppShell'
import { RequireAdmin, RequireAdministrador, RequireAuth, RequireOwner, RootRedirect } from './routes/guards'
import { ConversationsPage } from './pages/app/ConversationsPage'
import { ChannelAccountsPage } from './pages/app/ChannelAccountsPage'
import { KnowledgeBasePage } from './pages/app/KnowledgeBasePage'
import { MembersPage } from './pages/app/MembersPage'
import { EmpresaSociedadesPage } from './pages/app/EmpresaSociedadesPage'
import { AdministradoresPage } from './pages/app/AdministradoresPage'
import { EmpresaDashboardPage } from './pages/app/EmpresaDashboardPage'
import { EmpresaContactosPage } from './pages/app/EmpresaContactosPage'
import { PerfilPage } from './pages/PerfilPage'
import { SettingsPage } from './pages/SettingsPage'
import { OverviewPage } from './pages/admin/OverviewPage'
import { EmpresasPage } from './pages/admin/EmpresasPage'
import { EmpresaDetailPage } from './pages/admin/EmpresaDetailPage'
import { SociedadesPage } from './pages/admin/SociedadesPage'
import { SuperAdminsPage } from './pages/admin/SuperAdminsPage'

function PublicOnly({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth()
  if (isLoading) return null
  if (user) return <Navigate to="/" replace />
  return <>{children}</>
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route
        path="/admin"
        element={
          <RequireAuth>
            <RequireAdmin>
              <AppShell mode="admin" />
            </RequireAdmin>
          </RequireAuth>
        }
      >
        <Route index element={<OverviewPage />} />
        <Route path="empresas" element={<EmpresasPage />} />
        <Route path="empresas/:empresaId" element={<EmpresaDetailPage />} />
        <Route path="sociedades" element={<SociedadesPage />} />
        <Route path="super-admins" element={<SuperAdminsPage />} />
        <Route path="perfil" element={<PerfilPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>

      <Route
        path="/app"
        element={
          <RequireAuth>
            <AppShell mode="tenant" />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="conversaciones" replace />} />
        <Route path="conversaciones" element={<ConversationsPage />} />
        <Route path="conversaciones/:phone" element={<ConversationsPage />} />
        <Route path="whatsapp" element={<RequireAdministrador><ChannelAccountsPage /></RequireAdministrador>} />
        <Route path="base-de-conocimiento" element={<RequireAdministrador><KnowledgeBasePage /></RequireAdministrador>} />
        <Route path="miembros" element={<RequireAdministrador><MembersPage /></RequireAdministrador>} />
        <Route path="dashboard" element={<RequireOwner><EmpresaDashboardPage /></RequireOwner>} />
        <Route path="contactos" element={<RequireOwner><EmpresaContactosPage /></RequireOwner>} />
        <Route path="sociedades" element={<RequireOwner><EmpresaSociedadesPage /></RequireOwner>} />
        <Route path="administradores" element={<RequireOwner><AdministradoresPage /></RequireOwner>} />
        <Route path="perfil" element={<PerfilPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>

      <Route path="*" element={<RootRedirect />} />
    </Routes>
  )
}

export default App
